// extracted by mini-css-extract-plugin
export default {"editButton":"salaryHold_editButton__jVJFZ","TableBody":"salaryHold_TableBody__yA-WO"};